import MojitoCore from 'mojito/core';
import FlexPane from 'presentation/components/flex-pane/index.js';
import Button from 'presentation/components/button/index.js';
import Text from 'presentation/components/text/index.js';
import RotatableImage from 'presentation/components/rotatable-image/index.js';

const classUtils = MojitoCore.Base.classUtils;

export default function QuickNavigationButton(props) {
    const {
        mojitoTools: { config },
        title,
        subTitle,
        subTitleContent,
        disabled,
        onClick,
        isExpanded,
        class: className,
    } = props;

    return (
        <Button
            class={classUtils.classNames('ta-quickNavigationButton', className)}
            config={config.container}
            onClick={onClick}
            disabled={disabled}
        >
            {props.children}
            <Text class="ta-titleText" config={config.titleLabel}>
                {title}
            </Text>
            <FlexPane config={config.subTitleContainer}>
                {subTitleContent || (
                    <Text class="ta-subTitleText" config={config.subTitleLabel}>
                        {subTitle}
                    </Text>
                )}
                {!disabled && (
                    <RotatableImage
                        config={config.expandButtonIcon}
                        angle={isExpanded ? '0deg' : '180deg'}
                    />
                )}
            </FlexPane>
        </Button>
    );
}
